import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getRoles } from '@api/users';

import { rolesFormatted } from '@utils/formatter';

import { TRole } from '@interfaces/user/user';

import { ROLES } from '@constants/queryKeys';

interface IUseRoleProps {
	organizationId?: string | null;
	isExistUserAdmin?: boolean;
}

export const useQueryRoles = (props?: IUseRoleProps) => {
	const {
		organizationId,
		isExistUserAdmin = false,
	} = props || {};

	const {
		accessPermission: {
			assetOwnerOrganizationAdministrator,
			networkOperatorOrganizationAdministrator,
			platformOwnerAdministrator,
			assetConsumerOrganizationAdministrator,
		},
	} = useAppSelector(auth);

	const {
		data,
		isLoading: isLoadingRoles,
		isFetching: isFetchingRoles,
	} = useQuery({
			queryKey: [ROLES, organizationId, isExistUserAdmin],
			queryFn: () => getRoles(organizationId),
			select: (roles: Array<TRole>) => rolesFormatted(roles),
			refetchOnWindowFocus: false,
			enabled: [assetOwnerOrganizationAdministrator
			|| networkOperatorOrganizationAdministrator
			|| platformOwnerAdministrator
			|| assetConsumerOrganizationAdministrator],
		},
	);

	return {
		roles: data || [],
		isLoadingRoles: isLoadingRoles && isFetchingRoles,
	};
};

